import { makeStyles, Text, tokens } from '@fluentui/react-components';
import { SparkleRegular } from '@fluentui/react-icons';

type Props = {
  className?: string;
};

const useStyles = makeStyles({
  container: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: tokens.spacingHorizontalS,
    padding: `${tokens.spacingVerticalS} ${tokens.spacingHorizontalM}`,
    margin: `0 15px ${tokens.spacingVerticalM}`,
    backgroundColor: tokens.colorBrandBackground2,
    borderLeft: `3px solid ${tokens.colorBrandStroke1}`,
    borderRadius: tokens.borderRadiusMedium,
  },
  icon: {
    color: tokens.colorBrandForeground1,
    fontSize: '16px',
    lineHeight: '20px',
    flexShrink: 0,
  },
  text: {
    color: tokens.colorNeutralForeground2,
    lineHeight: '20px',
  },
});

export const AIGeneratedDisclaimer = ({ className }: Props) => {
  const styles = useStyles();
  return (
    <div className={className ? `${styles.container} ${className}` : styles.container}>
      <SparkleRegular className={styles.icon} />
      <Text size={200} className={styles.text}>
        Ce contenu a été généré automatiquement par intelligence artificielle.
        Il peut contenir des erreurs ou des approximations — merci de vérifier
        les informations importantes.
      </Text>
    </div>
  );
};
